import { Grid, Box, Typography } from '@mui/material';
import * as T from '../../components/Typography';

import SurveyCard from '../../components/SurveyCard';
import Error from '../../components/Error';
import InsightCardList from '../../components/InsightCard';
import FAQSection from '../../components/FAQ';
import Notification from '../../components/Notification';
import SurveyProgress from '../../components/SurveyProgress';
import PaymentPendingCard from '../../components/PaymentPendingCard';

const StoryBook = () => {
  return (
    <Grid container flexDirection="column" spacing={4} padding={4}>
      <Box width="100%" textAlign="center" marginBottom={4}>
        <T.H1>StoryBook</T.H1>
        <Typography variant="subtitle1">
          A showcase of common components
        </Typography>
      </Box>

      <Box width="100%" maxWidth="1216px" marginBottom={4}>
        <T.H1>Error Component</T.H1>
        <Error />
      </Box>

      <Box width="100%" maxWidth="1216px" marginBottom={4}>
        <T.H1>SurveyCard Component</T.H1>
        <Box marginTop={4}>
          <SurveyCard
            status="closed"
            date="15 March 2024"
            onDownload={() => console.log('Download clicked')}
            onAction={() => console.log('View survey clicked')}
          />
        </Box>
        <Box marginTop={4}>
          <SurveyCard
            status="open-start"
            date="15 March 2024"
            onDownload={() => console.log('Download clicked')}
            onAction={() => console.log('View survey clicked')}
          />
        </Box>
        <Box marginTop={4}>
          <SurveyCard
            status="open-continue"
            date="15 March 2024"
            onDownload={() => console.log('Download clicked')}
            onAction={() => console.log('View survey clicked')}
          />
        </Box>
        <Box marginTop={4}>
          <SurveyCard
            status="completed"
            date="15 March 2024"
            onDownload={() => console.log('Download clicked')}
            onAction={() => console.log('View survey clicked')}
          />
        </Box>
        <Box marginTop={4}>
          <SurveyCard
            status="report-ready"
            date="15 March 2024"
            onDownload={() => console.log('Download clicked')}
            onAction={() => console.log('View survey clicked')}
          />
        </Box>
      </Box>
      <Box width="100%" maxWidth="1216px" marginBottom={4}>
        <T.H1>Insight Cards</T.H1>
        <InsightCardList />
      </Box>
      <Box width="100%" maxWidth="1216px" marginBottom={4}>
        <T.H1>FAQs</T.H1>
        <FAQSection />
      </Box>
      <Box width="100%" maxWidth="1216px" marginBottom={4}>
        <T.H1>Notifications</T.H1>
        <Notification
          type="success"
          message="A password reset link has been sent to test@test.com."
        />
        <Notification
          type="error"
          message="A password reset link has been sent to test@test.com."
        />
        <Notification
          type="warning"
          message="A password reset link has been sent to test@test.com."
        />
      </Box>
      <Box marginTop={4}>
        <SurveyProgress />
      </Box>
      <Box width="100%" maxWidth="1216px" marginBottom={4}>
        <T.H1>Payment Pending Card</T.H1>
        <PaymentPendingCard paymentDueDate="15 March 2024" />
      </Box>
    </Grid>
  );
};

export default StoryBook;
